const edgeConfig = {
  basePath: "/api/.ory",
  baseOptions: {
    withCredentials: true
  }
};

export { edgeConfig };
//# sourceMappingURL=index.mjs.map
